import React from 'react';
import { PageCard, PageCardWrapper } from '@ui';
import { SplitPage } from '@ui';
import { PublicPageMessaging } from '@ui/PublicPageMessaging';
import styled from 'styled-components';
import { SignInForm } from '@containers/authentication/SignInForm';
import { useSearchParams } from 'react-router-dom';
import { Container } from '@ui';
import { useLocationUpdate } from '@hooks/application/useLocationSafe';

const SessionExpiredNotice = styled.div`
  padding: 16px;
  font-size: 14px;
  font-weight: 700;

  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.themeColors.primaryCtaButton};
  color: ${({ theme }) => theme.themeColors.text};

  * {
    color: ${({ theme }) => theme.themeColors.text};
  }
`;
const SignInFormWrapper = styled.div`
  ${PageCardWrapper} {
    padding: 24px;

    -webkit-box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.1);
  }
`;

const SessionExpired = ({ message }) => {
  return (
    <Container bottom={16}>
      <SessionExpiredNotice>{message || 'Session Expired, please sign in again.'}</SessionExpiredNotice>
    </Container>
  );
};

function SignIn({ isPasswordVisible }) {
  const [showSessionExpired, setShowSessionExpired] = React.useState(false);
  const [ssoFailed, setSsoFailed] = React.useState(false);
  const [searchParams] = useSearchParams();
  const initialEmail = searchParams.get('email') || '';

  useLocationUpdate();

  React.useEffect(() => {
    const sessionExpiredParam = searchParams.get('sessionexpired');
    if (sessionExpiredParam === '1') {
      setShowSessionExpired(true);
    }
    if (searchParams.get('sso_failed') === '1') {
      setSsoFailed(true);
    }
  }, []);

  return (
    <SplitPage
      LeftComponent={<PublicPageMessaging />}
      RightComponent={
        <SignInFormWrapper>
          {showSessionExpired && <SessionExpired />}
          {ssoFailed && <SessionExpired message={'Sign in with company credentials failed. Please try again.'} />}
          <PageCard>
            <SignInForm isPasswordVisible={isPasswordVisible} initialEmail={initialEmail} />
          </PageCard>
        </SignInFormWrapper>
      }
    />
  );
}

export default SignIn;
